import { useEffect, useState } from 'react';
import { add } from 'date-fns';
import { getUnavailability } from '@general/api/onSchedAPI';

const reasonCodes = {
    GOOGLE: 'GCU',
    OUTLOOK: 'OCU',
    BLOCK: 'RAB',
};

const useOnSchedUnavailability = ({
    onSchedAPIToken,
    onSchedLocationID,
    onSchedResourceID,
    onSchedServiceID,
    startDate,
    endDate,
    tzOffset,
    CALENDAR_TIME_SLOT,
    BLOCK_TIME_SLOT,
}) => {
    const [onSchedUnavailability, setOnSchedUnavailability] = useState(null);

    useEffect(() => {
        (async () => {
            const {
                data: { unavailableTimes },
            } = await getUnavailability({
                apiToken: onSchedAPIToken,
                locationId: onSchedLocationID,
                resourceId: onSchedResourceID,
                serviceId: onSchedServiceID,
                startDate,
                endDate,
                tzOffset,
            });

            setOnSchedUnavailability(
                unavailableTimes
                    .filter(time =>
                        [reasonCodes.GOOGLE, reasonCodes.OUTLOOK, reasonCodes.BLOCK].includes(time.reasonCode)
                    )
                    .map(unavailableTime => {
                        const startDateObject = new Date(unavailableTime.startDateTime);
                        const endDateObject = new Date(unavailableTime.endDateTime);

                        return {
                            type:
                                unavailableTime.reasonCode === reasonCodes.GOOGLE ||
                                unavailableTime.reasonCode === reasonCodes.OUTLOOK
                                    ? CALENDAR_TIME_SLOT
                                    : BLOCK_TIME_SLOT,
                            title: unavailableTime.reason,
                            startDateTime: add(startDateObject, { minutes: startDateObject.getTimezoneOffset() }),
                            endDateTime: add(endDateObject, { minutes: endDateObject.getTimezoneOffset() }),
                            blockId: unavailableTime.reasonCode === reasonCodes.BLOCK ? unavailableTime.entityId : null,
                        };
                    })
            );
        })();
    }, [
        onSchedAPIToken,
        onSchedLocationID,
        onSchedResourceID,
        onSchedServiceID,
        startDate,
        endDate,
        tzOffset,
        CALENDAR_TIME_SLOT,
        BLOCK_TIME_SLOT,
    ]);

    return onSchedUnavailability;
};

export default useOnSchedUnavailability;
